export const CaretUp = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M6 0.624951L12 6.62495L10.925 7.69995L6 2.74995L1.075 7.67495L-9.61651e-08 6.59995L6 0.624951Z"
      fill="#B0B0B0"
    />
  </svg>
);
